import { M3Colors, SystemColors as SystemColorsBase } from '../../base/config/colors';
import { ThemeColorPalette, ThemeSystemColorPalette } from '../../colors.model';

export const SystemColors: ThemeSystemColorPalette = SystemColorsBase;

export const Colors: ThemeColorPalette = {
  // load default colors from base...
  ...SystemColors,
  ...M3Colors,

  // ...and override with specific colors for this theme
  primary: {
    DEFAULT: '#2b4d58',
    0: '#000000',
    10: '#001017',
    20: '#001d24',
    25: '#002932',
    30: '#0b3640',
    35: '#17424c',
    40: '#235059',
    50: '#4a7682',
    60: '#63919d',
    70: '#7daeb9',
    80: '#98cbd6',
    90: '#b4e8f3',
    95: '#ccf4ff',
    98: '#e8faff',
    99: '#f4fdff',
    100: '#ffffff',
  },
  secondary: {
    DEFAULT: '#6a534c',
    0: '#000000',
    10: '#1a0f0d',
    20: '#331f1b',
    25: '#402824',
    30: '#4c322e',
    35: '#59413c',
    40: '#66504b',
    50: '#7e6963',
    60: '#987f78',
    70: '#b39c91',
    80: '#d0b9af',
    90: '#ede2db',
    95: '#f6efeb',
    98: '#f3fbfe',
    99: '#fdfbfb',
    100: '#ffffff',
  },
  tertiary: {
    DEFAULT: '#655674',
    0: '#000000',
    10: '#191b26',
    20: '#2e303b',
    25: '#393b47',
    30: '#454652',
    35: '#50525e',
    40: '#5c5d6a',
    50: '#757684',
    60: '#8f909e',
    70: '#aaaab9',
    80: '#c5c5d4',
    90: '#e2e1f1',
    95: '#f0efff',
    98: '#fbf8ff',
    99: '#fefbff',
    100: '#ffffff',
  },
  neutral: {
    DEFAULT: '#f3f2f7',
    0: '#000000',
    10: '#1b1c1c',
    20: '#303031',
    25: '#3b3b3c',
    30: '#464747',
    35: '#525253',
    40: '#5e5e5f',
    50: '#777777',
    60: '#919091',
    70: '#acabab',
    80: '#c7c6c6',
    90: '#e4e2e2',
    95: '#f2f0f0',
    98: '#fbf9f9',
    99: '#fefcfc',
    100: '#ffffff',
  },
  'neutral-variant': {
    DEFAULT: '#4a4a4a',
    0: '#000000',
    10: '#191c1d',
    20: '#2e3132',
    25: '#393c3d',
    30: '#444748',
    35: '#505354',
    40: '#5c5f60',
    50: '#757778',
    60: '#8f9192',
    70: '#aaabac',
    80: '#c5c7c8',
    90: '#e1e3e4',
    95: '#f0f1f2',
    98: '#f8f9fa',
    99: '#fbfcfd',
    100: '#ffffff',
  },
  error: {
    DEFAULT: '#bf1a2f',
    0: '#000000',
    10: '#b00925',
    20: '#bf1a2f',
    25: '#c82334',
    30: '#cc2237',
    35: '#d42a3b',
    40: '#de2c3e',
    50: '#ed323b',
    60: '#e84b57',
    70: '#de6e77',
    80: '#e9969d',
    90: '#fbcbd3',
    95: '#fdeaef',
    98: '#fcf2f3',
    99: '#fef9fa',
    100: '#ffffff',
  },
  accent: {
    DEFAULT: '#e8def8',
    0: '#000000',
    10: '#1e192b',
    20: '#332d41',
    25: '#3e384c',
    30: '#4a4458',
    35: '#554f64',
    40: '#625b70',
    50: '#7b748a',
    60: '#958da4',
    70: '#b0a7bf',
    80: '#cbc2db',
    90: '#e8def8',
    95: '#f6eeff',
    98: '#fdf7ff',
    99: '#fffbff',
    100: '#ffffff',
  },
  success: {
    DEFAULT: '#018e42',
    0: '#000000',
    10: '#002114',
    20: '#00391f',
    25: '#004b27',
    30: '#005e30',
    35: '#00723a',
    40: '#018e42',
    50: '#2ead60',
    60: '#5acb7f',
    70: '#85e89e',
    80: '#b1f6be',
    90: '#d5fce0',
    95: '#ebfdf0',
    98: '#f5fef8',
    99: '#fafffb',
    100: '#ffffff',
  },
  warning: {
    DEFAULT: '#fb5012',
    0: '#000000',
    10: '#7e1e00',
    20: '#a02b00',
    25: '#b93a00',
    30: '#d04a00',
    35: '#e05a00',
    40: '#f06a00',
    50: '#f97a00',
    60: '#ff8a00',
    70: '#ff9a00',
    80: '#ffb200',
    90: '#ffca00',
    95: '#ffdb00',
    98: '#ffec00',
    99: '#fff600',
    100: '#ffffff',
  },
  info: {
    DEFAULT: '#006c59',
  },
  surface: {
    DEFAULT: '#ece6f0',
  }
};
